<template>
  <div class="mypage mypackage">
    <div class="mb30">
      <h1 class="boxTitle mb15 toCapitalize notranslate">MY PACKAGE</h1>
      <!-- <div v-if="message" class="noData notranslate">
        {{ locale.guest_info_nodata }}
        <br />
        {{ locale.access_correct_path }}
      </div>
      <div v-else></div> -->
      <div v-if="packageList && packageList.length > 0">
        <div v-if="packageList.length > 0">
          <PackageComponent
            v-for="pkg in packageListWithoutTicket"
            :key="pkg.gpId"
            :locale="locale"
            :lang="lang"
            :gpId="pkg.gpId"
            :packageCode="pkg.packageCode"
            :packageDesc="pkg.packageDesc"
            :orderType="pkg.orderType"
            :packageCreateat="pkg.createat"
            :packageService="pkg.packageService" />
          <Mypage
            v-if="mypageTypes && mypageTypes.length > 0"
            :locale="locale"
            :mypageTypes="mypageTypes" />
        </div>
        <div v-else class="noData notranslate">
          {{ locale.package_component_nodata }}
        </div>
      </div>
      <div v-else-if="packageList && !packageList.length" class="noData">{{ locale.mypackage_list_nodata }}</div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { DateTime } from 'luxon'
import regExp from '@/common/regExp'
import Mypage from '@/components/Mypackage/Mypage'
import PackageComponent from '@/components/Mypackage/PackageComponent'

export default {
  name: 'Mypackage',
  props: [
    'lang',
    'locale',
    'roomKey',
  ],
  components: {
    Mypage,
    PackageComponent
  },
  computed: {
    ...mapGetters({
      getGuestUserInfo: 'guest/getGuestUserInfo'
    }),
    setting () {
      return this.$store.state.common.setting
    },
    pointColors () {
      return this.$store.getters['common/getPointColors']
    },
    guestUserInfo () {
      return this.getGuestUserInfo
    },
    isFrameFalse () {
      const authInfo = this.$store.getters['authentication/getAuthInfo']
      return authInfo && authInfo.frame === 'false'
    },
    packageListWithoutTicket () {
      const packageList = this.packageList || []
      return packageList.map(pkg => {
        const pkgService = (pkg && pkg.packageService) || []
        return {
          ...pkg,
          ...pkgService && {
            packageService: pkgService.filter(x => x && x.linkData && x.linkData.type !== 'ticket')
          }
        }
      }).filter(pkg => pkg.packageService && pkg.packageService.length)
    }
  },
  created () {
  },
  async mounted () {
    this.$nextTick(() => {
      this.init()
      // if (!this.guestUserInfo || this.guestUserInfo.error) {
      //   this.message = 'noData'
      // } else {
      //   this.message = null
      // }
    })
  },
  data () {
    return {
      message: null,
      packageList: null,
      packageService: null,
      mypageTypes: null
    }
  },
  methods: {
    track () {
      const site = this.$store.state.authentication.site
      const routerPath = this.$route.path
      const path = `${site}${routerPath}`
      this.$gtag.pageview({
        page_path: path,
        page_title: 'mypackage'
      })
    },
    async init () {
      const res = await this.$store.dispatch('guest/getGuestPackageService')
      if (res && res.data && res.data.message && res.data.message.package) {
        this.message = null
        this.packageList = res.data.message.package.filter(x => x.packageService &&  Object.values(x.packageService).filter(s => s.isActive).length > 0)
          .map(x => {
            const ps = Object.values(x.packageService)
            return {
              ...x,
              packageService: ps.map(s => {
                const linkType = s.linkType && s.linkType.toLowerCase()
                return {
                  psId: s.psId,
                  index: s.index && parseInt(s.index || 0),
                  linkData: {
                    type: linkType,
                    [`${linkType}Id`]: s.linkUUID,
                    target: false,
                    frame_false: this.isFrameFalse
                  },
                  linkText: s.linkContent
                }
              }).sort((a, b) => a.index - b.index) || []
            }
          })
        this.mypageTypes = res.data.message.myPageTypes
      }
    }
  }
}
</script>
